import { Component, signal, OnInit, OnDestroy, inject } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-not-found',
  standalone: true,
  templateUrl: './not-found.component.html'
})
export class NotFoundComponent implements OnInit, OnDestroy {
  private router = inject(Router);
  private intervalId: number | null = null;
  
  countdown = signal(5);

  ngOnInit() {
    this.intervalId = setInterval(() => {
      const currentCount = this.countdown();
      if (currentCount > 1) {
        this.countdown.set(currentCount - 1);
      } else {
        this.redirectToOpportunities();
      }
    }, 1000);
  }

  private redirectToOpportunities() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    this.router.navigate(['/participation-opportunities']);
  }

  onBrowseOpportunities() {
    this.redirectToOpportunities();
  }

  ngOnDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }
}
